<template>
    <div>
      <el-header style="height: 90px" v-if="($store.get('user') && $store.get('user').roleName !== 'admin') || !$store.get('user')">
        <div class="header-content">
          <div :style="logo" title="上海仁格人力资源有限公司" @click="aboutUsClick()"></div>
          <div class="menu-item" @click="goPage('Home')" :class="{'matched-cur-page': $route.name === 'Home'}">首页</div>
          <div class="menu-item" @click="goPage('JobWanted')" :class="{'matched-cur-page': $route.name === 'JobWanted'}">求职</div>
          <div class="menu-item" @click="goPage('Recruit')" :class="{'matched-cur-page': $route.name === 'Recruit'}">招聘</div>
          <div v-if="($store.get('user') && $store.get('user').roleName !== 'jobseeker')" class="menu-item" @click="goPage('TalentsPool')" :class="{'matched-cur-page': $route.name === 'TalentsPool'}">人才市场</div>
          <div class="menu-item" @click="goPage('SocialSecurity')" :class="{'matched-cur-page': $route.name === 'SocialSecurity'}">社保基纳</div>
<!--          <span class="register-login" @click="goHomePage('Login')" v-if="currentRouter !== 'Login'">注册/登录</span>-->
          <user-info style="float: right;"></user-info>
<!--          <span class="about-us" @click="aboutUsClick()">上海仁格人力资源有限公司</span>-->
        </div>
      </el-header>

      <el-header style="height: 90px" v-if="($store.get('user') && $store.get('user').roleName === 'admin')">
        <div class="header-content">
          <div :style="logo" title="上海仁格人力资源有限公司" @click="aboutUsClick()"></div>
          <div class="menu-item" @click="goPage('HomeManage')" :class="{'matched-cur-page': $route.name === 'HomeManage'}">首页管理</div>
          <div class="menu-item" @click="goPage('NewsManage')" :class="{'matched-cur-page': $route.name === 'NewsManage'}">新闻管理</div>
          <div class="menu-item" @click="goPage('RecruiterReview')" :class="{'matched-cur-page': $route.name === 'RecruiterReview'}">招聘审核</div>
          <div class="menu-item" @click="goPage('ReceiveOrder')" :class="{'matched-cur-page': $route.name === 'ReceiveOrder'}">社保管理</div>
          <div class="menu-item" @click="goPage('TalentsPool')" :class="{'matched-cur-page': $route.name === 'TalentsPool'}">人才市场</div>
          <!--          <span class="register-login" @click="goHomePage('Login')" v-if="currentRouter !== 'Login'">注册/登录</span>-->
          <user-info style="float: right;"></user-info>
          <!--          <span class="about-us" @click="aboutUsClick()">上海仁格人力资源有限公司</span>-->
        </div>
      </el-header>
    </div>
</template>

<script>
import UserInfo from '../UserInfo/UserInfo'
export default {
  name: 'HeaderComponent',
  components: {UserInfo},
  data () {
    return {
      logo: {
        backgroundImage: `url(${require('../../assets/logo.jpg')})`,
        width: '120px',
        height: '90px',
        display: 'inline-block',
        position: 'absolute',
        backgroundSize: 'inherit',
        borderRadius: '50%',
        backgroundPosition: '-1px -15px',
        left: '-145px',
        cursor: 'pointer'
      }
    }
  },
  methods: {
    goPage (routerName) {
      if (routerName === this.$route.name) {
        return false
      }
      routerName = routerName || 'Home'
      this.$router.push({
        name: routerName,
        params: null
      })
    },
    aboutUsClick () {
      window.open('http://rengerenli.com/about.php', '_blank')
    }
  },
  created () {
    console.log(this.$route.name)
  },
  mounted () {

  }
}
</script>

<style scoped>
  .header-content {
    width: 1200px;
    margin: auto;
    text-align: left;
    position: relative;
    height: 90px;
    /*background: #409eff;*/
  }

  .el-header {
    background-color: #409eff;
    color: #ffffff;
    text-align: center;
    line-height: 90px;
  }

  .about-us {
    float: right;
  }
  .matched-cur-page::before {
    position: absolute;
    content: '';
    height: 5px;
    width: 100%;
    background: #ffffff;
    left: 0;
    bottom: 0;
    /*border-radius: 5px;*/
  }
  .menu-item {
    cursor: pointer;
    position: relative;
    display: inline-block;
    font-weight: 600;
    font-size: 22px;
    padding: 0 30px;
  }
  .register-login {
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/components/Head/HeaderComponent.vue